import type { MirroredFeatureFlags } from "./feature-flags-context";

/**
 * Same-origin bridge to the Markdoc docs site: docs pages are static HTML in an
 * iframe with no LaunchDarkly client, so the SPA mirrors the evaluated flags
 * here and glofox-docs `scripts/assets/auth.js` reads them (plus the
 * `storage` event) to pick the legacy or Slice 6 topnav.
 */
export const FEATURE_FLAGS_STORAGE_KEY = "api-portal.feature-flags";

export function publishFeatureFlags(flags: MirroredFeatureFlags): void {
  try {
    window.localStorage.setItem(FEATURE_FLAGS_STORAGE_KEY, JSON.stringify(flags));
  } catch {
    // Quota or private mode: docs keep the legacy topnav (fail-closed).
  }
}
